/* eslint-disable @typescript-eslint/no-explicit-any */

import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface ApiResponse<T> {
  value: T;
}
interface IComprobarDocumento {
  codigo: string;
}

export const parametroBooleano = async (
  query: IComprobarDocumento
): Promise<any> => {
  try {
    const res = await apiClient.post<ApiResponse<any>>(
      Endpoints.ParametroBoolean,
      {
        codigo: `${query.codigo}`,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
